"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryKeyStore = void 0;
var keystores_1 = require("@near-js/keystores");
Object.defineProperty(exports, "InMemoryKeyStore", { enumerable: true, get: function () { return keystores_1.InMemoryKeyStore; } });
